/** Matches backend BILLING_OPEN_ACCESS — all plan features enabled in the UI. */
export const OPEN_ACCESS_FEATURES = {
  max_users: -1,
  max_spaces: -1,
  max_documents_per_space: -1,
  custom_domain: true,
  custom_branding: true,
  custom_css_js: true,
  analytics: true,
  api_access: true,
  priority_support: true,
  version_history_days: 365,
  storage_gb: 100,
  algolia_search: true,
  password_protection: true,
  sso: true,
};
